// import { TweenMax } from 'gsap';
import {state} from './state';
import {wheel} from './wheel';
import {whalehandle} from './whalehandle';

let menuSet = {
  menu: $('#l-menu'),
  menuTrigger: $('.menu-btn'),
  menuItem: $('.menu > .menu-list > li'),
  menuBg: $('.menu-bg'),
  scrollIcon: $('.mv-scrollPC'),
  linkWhaleMap: $('.mv-linkWhaleMap'),
  active:"is-active",
  currentIdx:1, //  1,2,3,4
};

export const menu={
  onClick:()=>{
    menuSet.menuTrigger.on(
      'click',
      (e)=>{
        if(!state.isSceneTrans){
          if (state.isMenu){
            state.isMenu=false;
            wheel.noMouseWheelEvt();
            // whalehandle.noMouseWheelEvt();
          }
          else {
            state.isMenu=true;
            wheel.mouseWheelEvt();
            // if (state.currentID==1){
            //   whalehandle.mouseWheelEvt();
            // }
            // else {
            //   wheel.mouseWheelEvt();
            // }
          }
          menuSet.menu.toggleClass(menuSet.active);
        }
      }
    );
  },
  onClickNoScroll:()=>{
    menuSet.menuTrigger.on(
      'click',
      (e)=>{
        if (state.isMenu){
          state.isMenu=false;
        }
        else {
          state.isMenu=true;
        }
        menuSet.menu.toggleClass(menuSet.active);
      }
    );
  },
  sceneAnchor:()=>{
    menuSet.menuItem.on(
      'click',
      (e)=>{
        let id=e.currentTarget.getAttribute('data-sceneid');
        if(!state.isSceneTrans){
          state.isSceneTrans=true;
          if(state.currentID !=id){
            wheel.onClickToNextScene(id);
          }
          else{
            if(id>=2){
              wheel.onClickToNextScene(id);
            }
            else{
              state.isSceneTrans=false;
              state.isMenu=true;
              // whalehandle.mouseWheelEvt();
            }
          }
        }
        menuSet.menu.toggleClass(menuSet.active);
      }
    )
    menuSet.scrollIcon.on(
      'click',
      (e)=>{
        if(!state.isSceneTrans){
          state.isSceneTrans=true;
          wheel.noMouseWheelEvt();
          // whalehandle.noMouseWheelEvt();
          wheel.onClickToNextScene(1);
        }
      }
    )
    menuSet.linkWhaleMap.on(
      'click',
      (e)=>{
        let id=e.currentTarget.getAttribute('data-sceneid');
        wheel.onClickToNextScene(id);
      }
    )
  },
  sceneAnchorNoScroll:()=>{
    $('.menu-list > li > a').on(
      'click',
      function(event) {
        event.preventDefault();
        let href = $(this).attr("href");
        menuSet.menu.removeClass(menuSet.active);
        $('html,body').stop().animate(
          {
            scrollTop: $(href).offset().top
          },
          800,
          'swing'
        );
      }
    )
    $('.mv-scroll > a').on(
      'click',
      function(event) {
        event.preventDefault();
        let href = $(this).attr("href");
        menuSet.menu.removeClass(menuSet.active);
        $('html,body').stop().animate(
          {
            scrollTop: $(href).offset().top
          },
          500,
          'swing'
        );
      }
    )
    $('.mv-linkWhaleMap > a').on(
      'click',
      function(event) {
        event.preventDefault();
        let href = $(this).attr("href");
        menuSet.menu.removeClass(menuSet.active);
        $('html,body').stop().animate(
          {
            scrollTop: $(href).offset().top
          },
          500,
          'swing'
        );
      }
    )
  },
};
